module.exports = __webpack_public_path__ + "img/location_other.dd6d185f.png";